module.exports = __webpack_public_path__ + "img/actu_defaut.cf51baec.jpg";